import { RemoteHandleMissedActivitiesJustifications } from 'data/usecases';
import { HandleMissedActivitiesJustificationsUseCaseInterface } from 'domain/usecases';
import { makeApiUrlMissedActivitiesJustifications } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeHandleMissedActivitiesJustifications =
  (): HandleMissedActivitiesJustificationsUseCaseInterface =>
    new RemoteHandleMissedActivitiesJustifications(
      makeApiUrlMissedActivitiesJustifications(),
      makeAxiosHttpClient(),
    );
